import { BasePlugin, BaseStats, mergePluginOption, RequestInfo, RequestType } from '@fpkg/stats-core';

import { isNeedReport } from '../utils';
import WebStats from '../WebStats';
import { captureXMLHttpRequest, AjaxOpt } from '../data-capture-funcs/ajax';

const ignoreListDefault: Array<RegExp> = [
  /ubs\.(sit\.)?sf-express\.com/i, // 神策上报地址
  /ump\.(sit\.)?sf-express\.com/i, // cx apm上报地址
  /v\.(sit\.)?sf-express.com\/api\/logs\/info\/up/i, // 告警上报地址
  /cas-captcha\.(sit\.)?sf-express\.com/, // 滑块请求
];

/**
 * ajax请求监控
 */
export default class AjaxPlugin implements BasePlugin {
  name = 'ajax';

  stats?: WebStats;

  option: AjaxOpt = {
    blackList: [], // 忽略请求list，可以字符串和正则表达式
    // 验证http状态
    validateHttpStatus: (status) => (status >= 200 && status < 300) || status === 302,
    validateJsonRes: (result) => result.success === true, // 校验业务请求是否ok，只有json格式的响应才会调用。默认为：(result) => result.success === true
    headerAddTraceId: true, // 非跨域请求默认都添加traceid
    crossOriginWhiteList: [],
  };

  // 大前端apm的appCode
  appCode = '';

  constructor(option: AjaxOpt | null | boolean) {
    mergePluginOption(this.option, option);
  }

  report(info: RequestInfo) {
    if (this.stats) {
      const reportData = { ...info };

      if (
        reportData.type !== RequestType.ok &&
        this.option.event_level &&
        isNeedReport({
          url: reportData.http_url,
          status: reportData.http_status,
          response: reportData.response_body,
        })
      ) {
        reportData.event_level = this.option.event_level; // event_level设置为error时会上报一份到顺丰云日志
      }

      this.stats.event(reportData);
      this.stats.$bus.$emit('ON_AJAX_EVENT', reportData);
    }
  }

  initAjaxCapture(ajaxObj: typeof XMLHttpRequest, microApp?: string, local?: Location) {
    // 通过stats.config方式获取其他插件的配置项
    // @ts-ignore
    const { appCode = '', dsn = '' } = this.stats.config.plugins.sfapm || {};
    // @ts-ignore
    const { logUrl = '' } = this.stats.config.plugins.sflogs || {};

    // 忽略自定义的大前端上报地址
    dsn && ignoreListDefault.push(new RegExp(dsn));
    // 忽略自定义的顺丰云日志上报地址
    logUrl && ignoreListDefault.push(new RegExp(logUrl));

    captureXMLHttpRequest(
      ajaxObj,
      local || window.location,
      {
        ...this.option,
        appCode,
        ignoreList: ignoreListDefault,
      },
      (info: RequestInfo) => {
        const reportData: RequestInfo = {
          ...info,
        };
        if (microApp) {
          reportData.micro_app = microApp;
        }
        this.report(reportData);
      }
    );
  }

  setup(stats: BaseStats) {
    this.stats = stats as WebStats;
    this.initAjaxCapture(XMLHttpRequest);
  }
}
